import Color from 'color'
export default {
  methods: {
    lightenColor(color) {
      return Color(color).lighten(0.7)
    },
    darkenColor(color) {
      return Color(color).darken(0.5)
    },

    formatEuro(num) {
      return (
        parseFloat(num)
          .toFixed(2)
          .toString()
          .replace('.', ',') + ' €'
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixins.js